import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(({
	chip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[200]),
		fontWeight: 400,
		fontSize: 12,
		marginLeft: 6
	}
}))

export default useStyles
